module.exports = __webpack_public_path__ + "static/media/memegenerator.5065f87a.PNG";